import {
  useTheme,
  Stack,
  Box,
  Paper,
  Typography,
  Chip,
  Button,
  Tooltip,
} from "@mui/material";
import { ptBR } from "@mui/x-data-grid/locales";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";

import useStyles from "../styles";
import { useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import { useState } from "react";
import ModalERP from "../../../componentes/easyLogs/modalERPv2";
import { use } from "react";

export const HistoricoEasyLog = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [openModal, setOpenModal] = useState(false);
  const [ipCliente, setIpCliente] = useState("");
  const [horario, setHorario] = useState("");
  // No modo Rede Neutra o IP público é uma das dimensões que dizem a quem
  // perguntar.
  const [ipPublico, setIpPublico] = useState("");

  const {
    CustomNoRowsOverlay,
    ButtonExports,
    loadingEvents,
    rowsEvents,
    eventos,
    protocolos,
    typeDB = "nat",
    erpStatus = false,
    modoErp = "unico",
  } = useOutletContext();
  const apiRefEvents = useGridApiRef();

  // Só no modo Rede Neutra: a grid soma logs de vários provedores.
  const colunaProvedor = {
    field: "Provedor",
    headerName: "Provedor",
    width: 170,
    renderCell: (params) => {
      if (!params.value) return "";
      // Ambíguo = mais de um provedor com sessão neste IP neste instante.
      // O backend devolve os dois; aqui a linha é marcada para conferência.
      if (!params.row?.ambiguo) return params.value;
      return (
        <Tooltip
          title={`Mais de um provedor tem sessão neste IP neste horário (${params.value}). Confira antes de usar este resultado.`}
        >
          <Chip
            size="small"
            color="warning"
            variant="outlined"
            label={params.value}
          />
        </Tooltip>
      );
    },
  };

  const comProvedor = (colunas) =>
    modoErp === "redeNeutra" ? [...colunas, colunaProvedor] : colunas;

  const columnsBpa = [
    { field: "Exporter", headerName: "Exporter", flex: 1 },
    {
      field: "Evento",
      headerName: "Evento",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack sx={styles.containerColumnChip} spacing={1}>
            {params.value == "1" && (
              <Chip sx={styles.chipAdd} label={"+ " + eventos?.[1]} />
            )}
            {params.value == "2" && (
              <Chip sx={styles.chipDel} label={"- " + eventos?.[2]} />
            )}
          </Stack>
        );
      },
    },
    {
      field: "Protocolo",
      headerName: "Protocolo",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return params.value ? (
          <Stack sx={styles.containerColumnChip} spacing={1}>
            <Chip
              sx={styles.chipProtocol}
              label={protocolos?.[parseInt(params.value)]}
            />
          </Stack>
        ) : null;
      },
    },
    {
      field: "IP Público",
      headerName: "IP Público",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "IP Privado",
      headerName: "IP Privado",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return erpStatus ? (
          <Button
            onClick={() => {
              setOpenModal(true);
              setIpCliente(params.value);
              setIpPublico(params.row?.["IP Público"] ?? "");
              setHorario(params.row?.Horário);
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                textDecoration: `underline ${theme.palette.easyLog.tertiary}`,
                color: theme.palette.easyLog.tertiary,
              }}
            >
              {params.value}
            </Typography>
          </Button>
        ) : (
          params.value
        );
      },
    },
    {
      field: "Porta Inicial",
      headerName: "Porta Inicial",
      width: 100,
      align: "center",
    },
    {
      field: "Porta Final",
      headerName: "Porta Final",
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Horário",
      headerName: "Horário",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (!params.value) return null;
        return dayjs(params.value).utc().format("DD/MM/YYYY HH:mm:ss");
      },
    },
  ];
  const columnsNat = [
    { field: "Exporter", headerName: "Exporter", flex: 1 },
    {
      field: "IP Público",
      headerName: "IP Público",
      width: 160,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "IP Privado",
      headerName: "IP Privado",
      width: 160,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return erpStatus ? (
          <Button
            onClick={() => {
              setOpenModal(true);
              setIpCliente(params.value);
              setIpPublico(params.row?.["IP Público"] ?? "");
              setHorario(params.row.Horário);
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                textDecoration: `underline ${theme.palette.easyLog.tertiary}`,
                color: theme.palette.easyLog.tertiary,
              }}
            >
              {params.value}
            </Typography>
          </Button>
        ) : (
          params.value
        );
      },
    },
    {
      field: "Porta",
      headerName: "Porta ",
      width: 120,
      align: "center",
    },

    {
      field: "Horário",
      headerName: "Horário",
      width: 210,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        //let data = new Date(params.value).toLocaleString();
        return dayjs(params.value)
          .tz(dayjs.tz.guess()) // Converte para o timezone do navegador
          .format("DD/MM/YYYY HH:mm:ss");
      },
    },
  ];
  return (
    <Paper
      sx={{
        ...styles.paper,
        width: "100%",
      }}
    >
      <Stack sx={styles.containerButtomDataGrid}>
        <ButtonExports
          apiRef={apiRefEvents}
          columns={comProvedor(typeDB === "bpa" ? columnsBpa : columnsNat)}
        />
      </Stack>

      <Box sx={styles.boxType}>{typeDB === "bpa" ? "CGNAT" : "NAT"}</Box>
      <Typography sx={styles.titlePaper}>
        <Box sx={styles.bar} />
        Histórico de Logs
      </Typography>
      <DataGrid
        apiRef={apiRefEvents}
        loading={loadingEvents}
        density="compact"
        sx={{ ...styles.dataGrid, "--DataGrid-overlayHeight": "300px" }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 100,
            },
          },
        }}
        hideFooter={true}
        getRowHeight={(model) => {
          if (!model?.model?.Horário) {
            return 1;
          }
          return;
        }}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        }}
        columnVisibilityModel={{ id: false }}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        rows={rowsEvents}
        columns={comProvedor(typeDB === "bpa" ? columnsBpa : columnsNat)}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        disableRowSelectionOnClick
      />
      <ModalERP
        ipCliente={ipCliente}
        ipPublico={ipPublico}
        horario={horario}
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      />
    </Paper>
  );
};
